/* eslint-disable */

import PubSub from 'pubsub-js';
import { PageEvents } from './page';
import { TextColorCheck } from '../utils/textColorCheck';

import './attached.scss';

const COMPONENT_NAME = 'attached';
const BEM = {
  BLOCK: COMPONENT_NAME,
};

/**
 * version    1.0
 * class      <type> (Attached)
 */
export class Attached {
  constructor() {
    const self = this;

    this._els = {};
    this._els.attached = $(`.${BEM.BLOCK}`);

    // init UI
    PubSub.subscribe(PageEvents.PAGE_READY, () => {
      self._els.attached.each(function () {
        const $instanceEl = $(this);

        TextColorCheck._checkBackground($instanceEl);
        self._insertIcons($instanceEl);
      });
    });
  }

  // private methods

  _insertIcons($instanceEl) {
    $instanceEl.find('.attached__icon-item').each(function() {
      const iconName = $(this).data('icon-attached') ? $(this).data('icon-attached') : 'social-share';
      const iconToAppend = `<svg role="img" class="svg-icon svg-icon--${iconName}" title="${iconName}"><use xlink:href="#sprite-${iconName}"></use></svg>`;

      $(this).find('a').prepend(iconToAppend);
    });
  }
}
